module.exports = __webpack_public_path__ + "static/media/25626147_1703513193057198_8433468485224063603_o.52db3fee.jpg";